"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var FlagNI = function FlagNI(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "411.6",
    height: "270.36",
    viewBox: "0 0 411.6 270.36"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M216.6-32.55H-193v-82.39a7.06,7.06,0,0,1,7.06-7.06H209.54a7.06,7.06,0,0,1,7.06,7.06Zm0,0",
    transform: "translate(194 123)",
    fill: "#41479b"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M209.54,146.36H-185.94A7.07,7.07,0,0,1-193,139.3V56.91H216.6V139.3a7.06,7.06,0,0,1-7.06,7.06Zm0,0",
    transform: "translate(194 123)",
    fill: "#41479b"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "90.45",
    width: "409.6",
    height: "89.44",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M11.8-13.68-9.74,18H33.34Zm0,0",
    transform: "translate(194 123)",
    fill: "#afebff"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-9.74,18-23.68,38.28h71L33.34,18Zm0,0",
    transform: "translate(194 123)",
    fill: "#557de6"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M17.31,16.23c.09-.18.18-.35.26-.53-.08.18-.17.35-.26.53Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M17.91,14.77c.05-.16.11-.31.16-.47-.05.16-.11.31-.16.47Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M16.58,17.56,16.9,17l-.32.52Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M19.87,11.66a1.71,1.71,0,0,0-.55.09,1.71,1.71,0,0,1,.55-.09Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M18.86,12a1.28,1.28,0,0,0-.49.84,1.24,1.24,0,0,1,.49-.84Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M18.21,21.45q.45.42.9.81A20.38,20.38,0,0,0,23.57,17l-.26.43a22.45,22.45,0,0,1-2-4.81,1.49,1.49,0,0,0-1.48-1c.27,2.36.85,6.7-1.66,9.79Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M24.59,14.77c.05-.16.11-.31.16-.47-.05.16-.11.31-.16.47Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M25.54,12a1.24,1.24,0,0,0-.49.84,1.24,1.24,0,0,1,.49-.84Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M24,16.23c.09-.18.18-.35.26-.53-.08.18-.17.35-.26.53Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M37.67,23.07a7.53,7.53,0,0,1-6.16-3.17A23.3,23.3,0,0,1,28,12.66a1.49,1.49,0,0,0-1.48-1h0c.33,2.82,1.09,8.46-3.49,11.41h-3l-.36-.29h0a3.08,3.08,0,0,1-3.8.72c-5.42-2.79-4.58-8.89-4.24-11.85a1.5,1.5,0,0,0-1.48,1,21.93,21.93,0,0,1-2,4.81c-.09-.14-.18-.28-.26-.43A21.73,21.73,0,0,0,13,22.79a3.08,3.08,0,0,1-3.8.72C3.81,20.72,4.65,14.62,5,11.66a1.48,1.48,0,0,0-1.47,1,22.08,22.08,0,0,1-2,4.81L1.29,17a21.73,21.73,0,0,0,5.06,5.75,3.08,3.08,0,0,1-3.8.72C-2.87,20.72-2,14.62-1.69,11.66h0a1.48,1.48,0,0,0-1.48,1A23.3,23.3,0,0,1-6.64,19.9a7.54,7.54,0,0,1-6.17,3.17h-2v2.54H38.41V23.07Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M14,15.7c.08.18.17.35.25.53-.08-.18-.18-.35-.25-.53Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M13.48,14.29c0,.17.11.32.16.48-.05-.16-.12-.31-.16-.48Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M13.18,12.83a1.32,1.32,0,0,0-.5-.84,1.32,1.32,0,0,1,.5.84Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M14.65,17l.31.52L14.65,17Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M15.81,18.79l0-.05c.11-.14.22-.29.32-.44-.1.15-.21.29-.32.44l-.32-.44.36.49Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M16.37,19.49c.12.15.24.3.37.44-.13-.14-.25-.29-.37-.44Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M17.72,21l-.35-.37.35.37Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M26.55,11.66h0a1.65,1.65,0,0,0-1,.33,1.24,1.24,0,0,0-.49.84,9.94,9.94,0,0,1-.3,1.46c-.05.17-.11.32-.16.48-.11.31-.22.62-.34.93s-.17.35-.26.53-.26.54-.42.81a20.38,20.38,0,0,1-4.46,5.22c-.3-.25-.6-.53-.9-.81,2.51-3.09,1.93-7.43,1.66-9.79h0a1.71,1.71,0,0,0-.55.09,1.68,1.68,0,0,0-.46.24,1.28,1.28,0,0,0-.49.83h0a10.21,10.21,0,0,1-.3,1.46c-.05.17-.11.32-.16.48-.11.31-.22.62-.34.93s-.17.35-.26.53-.26.54-.41.81l-.32.52c-.16.25-.32.5-.49.74s-.21.29-.32.44l-.32-.44c-.17-.24-.33-.49-.49-.74s-.21-.35-.31-.52-.29-.54-.42-.81-.18-.35-.25-.53-.24-.62-.34-.93c-.05-.16-.12-.31-.16-.48a8.79,8.79,0,0,1-.3-1.46h0a1.3,1.3,0,0,0-.5-.83,1.63,1.63,0,0,0-1-.33c-.34,3-1.18,9.06,4.24,11.85a3.24,3.24,0,0,0,2.88,0,3.87,3.87,0,0,1,1.75-.46h2.52c4.58-2.95,3.82-8.59,3.49-11.41Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M6.8,14.29c0,.17.11.32.16.48,0-.16-.12-.31-.16-.48Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M6.5,12.83A1.32,1.32,0,0,0,6,12a1.32,1.32,0,0,1,.5.84Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M7.3,15.7c.08.18.17.35.25.53-.08-.18-.17-.35-.25-.53Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M5,11.66a1.61,1.61,0,0,1,.54.09A1.61,1.61,0,0,0,5,11.66Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M9.23,23.51a3.08,3.08,0,0,0,3.8-.72A21.73,21.73,0,0,1,8,17c-.15-.27-.28-.54-.42-.81s-.17-.35-.25-.53A9.33,9.33,0,0,1,7,14.77c0-.16-.12-.31-.16-.47a9.12,9.12,0,0,1-.3-1.47A1.32,1.32,0,0,0,6,12a1.44,1.44,0,0,0-.46-.24A1.63,1.63,0,0,0,5,11.66c-.33,3-1.18,9.06,4.24,11.85Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M.12,14.29c0,.17.11.32.16.48-.05-.16-.11-.31-.16-.48Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M.62,15.7c.08.18.17.35.25.53-.08-.18-.17-.35-.25-.53Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-.18,12.83A1.28,1.28,0,0,0-.68,12a1.28,1.28,0,0,1,.5.84Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M2.56,23.51a3.09,3.09,0,0,0,3.8-.72A21.76,21.76,0,0,1,1.29,17c-.15-.27-.28-.54-.42-.81S.7,15.88.62,15.7s-.23-.61-.34-.93c-.05-.16-.11-.31-.16-.47a10.35,10.35,0,0,1-.3-1.47A1.28,1.28,0,0,0-.68,12a1.6,1.6,0,0,0-1-.33h0c-.33,3-1.18,9.06,4.25,11.85Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M1.12,1.58.81,2.79a40.08,40.08,0,0,1,22.83,0l-.31-1.21A44.15,44.15,0,0,0,12.23.18,44.29,44.29,0,0,0,1.12,1.58Zm0,0",
    transform: "translate(194 123)",
    fill: "#41479b"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M1.26,1.05c-.1.41-.21.81-.31,1.21a39.15,39.15,0,0,1,22.56,0c-.11-.4-.21-.8-.32-1.21a43.64,43.64,0,0,0-21.93,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#5aa0e6"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M1.39.57c-.11.4-.21.81-.32,1.21A37.91,37.91,0,0,1,12.23.11,37.46,37.46,0,0,1,23.38,1.78L23.07.57A41.83,41.83,0,0,0,12.23-.84,41.77,41.77,0,0,0,1.39.57Zm0,0",
    transform: "translate(194 123)",
    fill: "#9bc800"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M1.54,0c-.11.4-.22.81-.32,1.21a37.13,37.13,0,0,1,22,0C23.13.82,23,.41,22.92,0A40.79,40.79,0,0,0,12.23-1.4,40.68,40.68,0,0,0,1.54,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe14e"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M1.68-.54c-.11.41-.22.81-.32,1.22A35.49,35.49,0,0,1,12.23-1,35.42,35.42,0,0,1,23.09.68c-.1-.41-.21-.81-.31-1.22a40.17,40.17,0,0,0-21.1,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffb14e"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M1.74-.77c-.08.28-.15.57-.22.85a34.78,34.78,0,0,1,21.42,0c-.08-.28-.15-.57-.23-.85a39.42,39.42,0,0,0-21,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M47.28,39.5h-71a1.26,1.26,0,0,1-1.12-.66,1.29,1.29,0,0,1,.07-1.31L10.75-15.69a1.31,1.31,0,0,1,2.1,0L48.34,37.53a1.31,1.31,0,0,1,.06,1.31,1.26,1.26,0,0,1-1.12.66ZM-21.31,37H44.91L11.8-12.7Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M14.22,6.53a3,3,0,0,0-2.93-2.82A1.74,1.74,0,0,0,9.37,5.16a1.32,1.32,0,0,0,.56,1v0a1.34,1.34,0,0,0-.72,1.12c0,.76.79,1.37,1.77,1.43l.82,1.63.73-1.47a2.41,2.41,0,0,0,1.69-2.4Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "1",
    width: "409.6",
    height: "268.36",
    rx: "7",
    ry: "7",
    fill: "none"
  }));
};

var _default = FlagNI;
exports["default"] = _default;